import script from "./SelectCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCharts.vue?vue&type=script&setup=true&lang=js"

import "./SelectCharts.vue?vue&type=style&index=0&id=b6822936&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6822936"]])

export default __exports__